import { GenericMessage } from "../../lib/messages";
export const degrees = (value) => {
    if (value < 0 || value >= 360)
        throw new Error("Not a valid degree amount.");
    return value;
};
export class GeocodeMessage extends GenericMessage {
}
